import React from 'react';
import cn from "classnames";
import styles from "./Row.module.sass";
import Checkbox from '../../../../components/Checkbox';
import ToteDropdown from '../../Dropdown';
import Icon from '../../../../components/Icon';
import { useNavigate } from 'react-router';

const ToteTableRow = ({ data, checkedItems = {}, handleCheckboxChange,setToteMarkedToDelete,setToteMarkedToEmpty }) => {
  const navigate = useNavigate();

  const renderFilter = (filter) => (
    <ToteDropdown
      key={filter.tote_id}
      options={[
        {
          label: "Empty Tote",
          icon: <Icon name="block" size={16} />,
          onClick: () => handleEmpty(filter.tote_id),
        },
        {
          label: <span className="text-red-500">Delete Tote</span>,
          icon: <Icon name="trash" size={16} color="#FF6A55" />,
          onClick: () => handleDelete(filter.tote_id),
        },
      ]}
      classDropdownHead="px-4 py-2 rounded-md transition-colors"
      dropdownStyles={{ alignSelf: "end" }}
    />
  );

  const handleDelete = (id) => {
    setToteMarkedToDelete(id);
  };

  const handleEmpty = (id) => {
    setToteMarkedToEmpty(id);
  };

  const formatContents = (contents) => {
    if (Array.isArray(contents)) {
      const orderNumbers = contents
        .map(item => item.order?.name || item.order?.order_number)
        .filter(Boolean)
        .join(", ");
      return orderNumbers || "No orders";
    }
    return contents || "-";
  };

  const formatStatus = (status) => {
    if (!status) return "-";
    const formattedValue = status.replace(/_/g, " ");
    const capitalizedValue = formattedValue.charAt(0).toUpperCase() + formattedValue.slice(1);
    return (
      <div
        className={cn(styles.purchase, {
          "status-role-active": capitalizedValue === "EMPTY",
          "status-role-inactive": capitalizedValue !== "EMPTY",
        })}
      >
        {capitalizedValue}
      </div>
    );
  };

  const handleToteClick = (toteId) => {
    navigate(`/totes-details/${toteId}`);
  };
  
  const handleCheckboxClick = (e) => {
    e.stopPropagation(); 
  };

  const handleDropdownClick = (e) => {
    e.stopPropagation();
  };
  return (
    <div className={styles.row} onClick={() => handleToteClick(data.tote_id, data.tote_status)}>
      <div className={styles.col} onClick={handleCheckboxClick}>
        <Checkbox
          className={styles.checkbox}
          checked={checkedItems[data.tote_id] || false}
          onChange={(e) => {
            handleCheckboxChange(e, null, data.tote_id);
          }}
        />
      </div>
      <div className={cn(styles.col)}>
        {data.tote_id || "-"}
      </div>
     
      <div className={cn("w-[40%]",styles.col)}>
        {formatContents(data.contents)}
      </div>
       <div className={cn("whitespace-nowrap",styles.col)}>
       {data.used_by || "-"}
      </div>
      <div className={cn("whitespace-nowrap",styles.col)}>
       {formatStatus(data.tote_status)}
      </div>
      <div className={styles.col} onClick={handleDropdownClick}>
        {renderFilter(data)}
      </div>
    </div>
  );
};

export default ToteTableRow;